import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UserModel} from '../_models/user.model';

@Injectable({
    providedIn: 'root'
})

export class UsersService {

    constructor(private http: HttpClient) {
    }

    registerUser(user) {
        return this.http.post<UserModel>('/api/registerUser', user);
    }

    sendRegisterEmailConfirm(userId: string) {
        return this.http.get('/api/sendRegistrationEmail?userId=' + userId);
    }

    getCurrentUser() {
        return this.http.get('/api/getCurrentUser');
    }

    updateCurrentUser(user) {
        return this.http.put('/api/updateCurrentUser', user);
    }

    getAllUsers() {
        return this.http.get('/api/getAllUsers');
    }

    updateCurrentSubUser(user) {
        return this.http.put('/api/updateCurrentSubUser', user);
    }

    changePassword(oldPassword, newPassword) {
        return this.http.put('/api/changePassword?oldPassword=' + oldPassword + '&newPassword=' + newPassword, '');
    }

    resetNewPassword(passwordObject) {
        return this.http.post('/api/resetNewPassword', passwordObject);
    }

    sendResetUserPassword(email) {
        return this.http.get('/api/sendResetUserPassword?email=' + email);
    }

    loginGoogle(googleObject) {
        return this.http.post('/api/loginGoogle', googleObject);
    }

    createWorkTracker(workTrackerObject: object) {
        return this.http.post('/api/createWorkTracker', workTrackerObject);
    }

    endWorkTracker() {
        return this.http.put('/api/endWorkTracker', {});
    }

    getTeamMembers() {
        return this.http.get('/api/getTeamMembers');
    }

}
